export default __webpack_public_path__ + "static/media/I-2.f837a4f9.png";